import { useMutation, useQuery } from '@tanstack/react-query';
import * as DocumentService from '@/services/document';
import { toRQMutation, toRQQuery } from '@/utilities/service';
import { QueryKeys } from '@/types/query';

export function useUploadDocument(type: string) {
  const { isLoading, data, mutate } = useMutation({
    mutationFn: (data: { file: File | null }) => DocumentService.uploadDocument(type, data),
  });

  return toRQMutation(data, isLoading, mutate);
}

export function useDocument(type: string) {
  const { isFetching, isRefetching, data, refetch, remove } = useQuery({
    queryKey: [QueryKeys.GET_DOCUMENT, type],
    queryFn: () => DocumentService.getDocument(type),
    staleTime: Infinity,
  });

  return toRQQuery(data, isFetching, isRefetching, refetch, remove);
}

export function useCheckUpdatePermission() {
  const { isFetching, isRefetching, data, refetch, remove } = useQuery({
    queryKey: [QueryKeys.UPLOAD_DOCUMENT_PERMISSION],
    queryFn: () => DocumentService.checkUploadDocumentPermission(),
    staleTime: Infinity,
  });

  return toRQQuery(data, isFetching, isRefetching, refetch, remove);
}
